export const useIsCardholderNameRequired = (): boolean => {
  return false
}
